export class NXICommonConstants {
    static ShowLanguageSwitchPagesList: string[] = [
        // 'login',
        // 'login1',
        // 'welcome',
        // 'registration'
    ];
}
